<div id="main-banner" class="jumbotron jumbotron-fluid banner">
</div>
<div class="my-5 text-center container">
	<h2 class="text-cyan mb-4">Partagez des exépriences uniques,<br>
	et vendez à des gens de partout</h2>
	<p>L'agenda Akces est le plus soucieux de la qualité des évènements qu'il propose, afin de proposer des expériences uniques aux gens de partout.<br/>
	Les organisateurs d'évènements utilisent l'agenda Akces comme outil de communication, grâce à son audience variée. <br>
	Ils peuvent organiser, promouvoir et vendre des billets à des évènements de toute taille.<br/>
	En même temps, les personnes qui souhaitent vivre des moments uniques en particiapant à des évènements peuvent trouver rapidement l'expérience qui leur correspond et acheter des billets en quelques secondes.
	</p>
</div>
<div id="middle-banner" class="jumbotron jumbotron-fluid banner d-flex align-middle">
  <div class="container text-center">
    <h2 class="display-4 text-white text-caps">des évènements variés, et de toutes tailles</h2>
  </div>
</div>
<div class="jumbotron jumbotron-fluid color-banner text-center bg-cyan text-white py-4 m-0">
  <div class="container">
    <p class="text-violet">L'agenda AKCES propose aux organisateurs et d'héberger gratuitement des évènements de toute taille. <br>Les organisateurs peuvent choisir de publier ou non leurs évènements dans l'agenda, et modifier cela à tout moment.</p>
    <div class="row mt-4 mb-3">
    	<div class="col">
    		<i class="big-icon fa fa-birthday-cake"></i>
    		<h4 class="text-caps">anniversaire</h4>
	    </div>
	    <div class="col">
	    	<i class="big-icon fa fa-map"></i>
	    	<h4 class="text-caps">randonnée</h4>
	    </div>
	    <div class="col">
	    	<i class="big-icon fa fa-music"></i>
	    	<h4 class="text-caps">festival</h4>
	    </div>
	    <div class="col">
	    	<i class="big-icon fa fa-trophy"></i>
	    	<h4 class="text-caps">tournoi</h4>
	    </div>
    </div>
    <p>Et bien plus...</p>
    <h2 class="display-5 text-white text-caps my-4">découvrez tous les évènements auxquels vous pouvez vous inscrire sur akces</h2>
    <a href="https://akces.fr" target="_blank" title="Découvrir les évènements" class="btn dark my-3">Découvrir</a>
  </div>
</div>
<div class="row">
	<div class="col text-center text-violet p-4">
		<div class="container">
			<h2 class="display-4 text-caps">quand vous voulez, où vous voulez</h2>
			<img src="assets/imgs/solutions/supports.png" alt="" class="my-3">
			<p>Depuis votre mobile, votre tablette ou votre ordinateur,à l'aide d'une connexion internet, mettez en ligne votre évènement rapidement et touchez des gens de partout.</p>
		</div>
	</div>
	<div id="side-banner" class="col banner">
		
	</div>
</div>
<div class="jumbotron jumbotron-fluid color-banner bg-dark-blue text-center text-white py-4 m-0">
  <div class="container">
    <h2 class="display-4 text-white text-caps">un agenda gratuit, pour tous</h2>
    <p>Les organisateurs préfèrent l'agenda Akces, car il a été pensé pour chacun d'entre eux.<br/>Le mantra d'Akces est de rendre les évènements accessible à tous, sans barrière, pour dépasser les frontières.</p>
  </div>
</div>
<div class="jumbotron jumbotron-fluid color-banner bg-white text-violet text-center py-4">
  <div class="container">
    <h2 class="display-5 text-regular">La solution pour tous les organisateurs d'évènements, créez et référencez rapidement tous vos évènements</h2>
    <p>Inscrivez votre premier évènement et commencez à vendre gratuitement. Lorsque vous vendez un billet, vous ne payez rien. <br/> Akces fonctionne grâce aux frais de dossiers payés par la communauté lorsqu'elle achète ses billets.</p>
    <a href="/manage/event/create" title="Créer un évènement" class="btn">Créer un évènement</a>
  </div>
</div>